/* src/app/core/components/new-version-info/new-version-info.component.scss */
/*# sourceMappingURL=new-version-info.component.css.map */
